import fetch from '../utils/fetch'

// 获取开屏广告设置
export function getOpenScreenADSet(query) {
  return fetch({
    url: '/openscreenad/set',
    method: 'get',
    params: query
  })
}
// 获取首屏广告设置
export function getOpenScreenADIndexSet(query) {
  return fetch({
    url: '/homescreenad/set',
    method: 'get',
    params: query
  })
}
// 保存开屏广告设置
export function saveOpenScreenADSet(data) {
  return fetch({
    url: '/openscreenad/set',
    method: 'post',
    params: data
  })
}

// 保存开屏广告设置
export function saveOpenScreenADIndexSet(data) {
  return fetch({
    url: '/homescreenad/set',
    method: 'post',
    params: data
  })
}
